import { Backdrop, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, Grid } from '@material-ui/core'
import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import ButtonUI from '../../../components/ui/ButtonUI'
import PageTitle from '../../../components/ui/PageTitleUI'
import { useAuth } from '../../../hooks/auth'
import permissions from '../../../utils/Permissions'
import MvmMonitorExternalQueue from './MvmMonitorExternalQueue'
import MvmMonitorSheds from './MvmMonitorSheds'
import MvmMonitorSumary from './MvmMonitorSumary'
import { useStyles } from './Style'

const MvmMonitors: React.FC = () => {
    const classes = useStyles()
    const history = useHistory()
    const { t: _t } = useTranslation("General")
    const { t: tMonitor } = useTranslation("MvmMonitor")
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [tipo, setTipo] = useState('-');
    const { user, hasPermission } = useAuth();

    useEffect(() => {
        if (!hasPermission(permissions.MVM.Monitor))
            history.replace('NoPermission');
    }, [history, user])

    const openMonitor = (tipo:string) => {
        setTipo(tipo);
        setDialogOpen(true);
    };

    const closeMonitor = () => {
        setTipo('-');
        setDialogOpen(false);
    };

    return (
        <Container component="main">
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog
                classes={{ paper: classes.dialog}}
                open={dialogOpen}
                onClose={closeMonitor}
                fullWidth
                maxWidth="lg"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogContent style={{width: '100%!important', maxWidth: '100%!important'}}>
                <DialogContentText id="alert-dialog-description">
                    {tipo === 'FIAT_SUMMARY' && (
                        <MvmMonitorSumary plantId={1} />
                    )}

                    {tipo === 'FIAT_SHEDS' && (
                        <MvmMonitorSheds plantId={1} />
                    )}

                    {tipo === 'CAMPO_LARGO_SUMMARY' && (
                        <MvmMonitorSumary plantId={2} />
                    )}

                    {tipo === 'CAMPO_LARGO_SHEDS' && (
                        <MvmMonitorSheds plantId={2} />
                    )}

                    {tipo === 'JEEP_SUMMARY' && (
                        <MvmMonitorSumary plantId={3} />
                    )}

                    {tipo === 'JEEP_SHEDS' && (
                        <MvmMonitorSheds plantId={3} />
                    )}

                    {tipo === 'CAMPOL_JEEP_SUMMARY' && (
                        <div style={{display: 'flex', flexDirection: 'row'}}>
                            <MvmMonitorSumary plantId={2} />
                            <MvmMonitorSumary plantId={3} />
                        </div>
                    )}

                    {tipo === 'CAMPOL_JEEP_SHEDS' && (
                        <div style={{display: 'flex', flexDirection: 'row'}}>
                            <MvmMonitorSheds plantId={2} />
                            <MvmMonitorSheds plantId={3} />
                        </div>
                    )}

                    {tipo === 'MVM_MONITOR_EXTERNAL_QUEUE' && (
                        <MvmMonitorExternalQueue />
                    )}                    
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={closeMonitor}>{_t("close")}</Button>
                </DialogActions>
            </Dialog>
            <PageTitle title={tMonitor("receivingsMonitors")} />

            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <Grid container spacing={1}>
                        <Grid item xs={3} className={classes.center} >
                            <ButtonUI
                                color="primary"
                                size='large'
                                onClick={() => openMonitor('FIAT_SUMMARY')}
                                variant="contained">
                                {tMonitor("title_FIAT")}
                            </ButtonUI>
                        </Grid>

                        <Grid item xs={3} className={classes.center} >
                            <ButtonUI
                                color="primary"
                                size='large'
                                onClick={() => openMonitor('CAMPO_LARGO_SUMMARY')}
                                variant="contained">
                                {tMonitor("title_CAMPOLARGO")}
                            </ButtonUI>
                        </Grid>

                        <Grid item xs={3} className={classes.center} >
                            <ButtonUI
                                color="primary"
                                size='large'
                                onClick={() => openMonitor('JEEP_SUMMARY')}>
                                {tMonitor("title_JEEP")}
                            </ButtonUI>
                        </Grid>
                        <Grid item xs={3} className={classes.center} >
                            <ButtonUI
                                color="primary"
                                size='large'
                                onClick={() => openMonitor('CAMPOL_JEEP_SUMMARY')}>
                                {tMonitor("titleCampoLargoJeep")}
                            </ButtonUI>
                        </Grid>
                    </Grid>
                </div>
            </div>

            <br />
            <hr />
            <br />

            <PageTitle title={tMonitor("title_FIAT")} />

            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <Grid container spacing={1}>
                        <Grid item xs={3} className={classes.center} >
                            <ButtonUI
                                color="primary"
                                size='large'
                                onClick={() => openMonitor('FIAT_SHEDS')}
                                variant="contained">
                                {tMonitor("title_FIAT")}
                            </ButtonUI>
                        </Grid>

                        <Grid item xs={3} className={classes.center} >
                            <ButtonUI
                                color="primary"
                                size='large'
                                onClick={() => openMonitor('CAMPO_LARGO_SHEDS')}
                                variant="contained">
                                {tMonitor("title_CAMPOLARGO")}
                            </ButtonUI>
                        </Grid>

                        <Grid item xs={3} className={classes.center} >
                            <ButtonUI
                                color="primary"
                                size='large'
                                onClick={() => openMonitor('JEEP_SHEDS')}>
                                {tMonitor("title_JEEP")}
                            </ButtonUI>
                        </Grid>
                        <Grid item xs={3} className={classes.center} >
                            <ButtonUI
                                color="primary"
                                size='large'
                                onClick={() => openMonitor('CAMPOL_JEEP_SHEDS')}>
                                {tMonitor("titleCampoLargoJeep")}
                            </ButtonUI>
                        </Grid>
                    </Grid>
                </div>
            </div>

            <br />
            <hr />
            <br />
        </Container>
    )
}
export default MvmMonitors;
